<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>
<script setup>
import "./assets/style/index.scss";
import logger from "debug";

const config = useRuntimeConfig();
const cdnUrl = config.public.cdnUrl;
const isPortrait = ref(null);
const debug = logger("travvir:blogs:app");
const { locale } = useI18n();

useHead({
  htmlAttrs: {
    lang: () => locale.value,
  },
  style: [
    {
      textContent: `
        @font-face {
          font-family: Sharp Grotesk;
          src: url("${cdnUrl}/static/fonts/sharp-gotesk-medium.otf") format("opentype");
          font-weight: 500;
          font-style: normal;
          font-display: swap;
        }
        @font-face {
          font-family: Sharp Grotesk;
          src: url("${cdnUrl}/static/fonts/sharp-gotesk-light.otf") format("opentype");
          font-weight: 300;
          font-style: normal;
          font-display: swap;
        }
      `,
    },
  ],
});
const headers = useRequestHeaders(["referer"]);

//provide
provide("isPortrait", isPortrait);

//methods
const updateOrientation = () => {
  isPortrait.value = window.innerHeight > window.innerWidth;
};

function checkServerOrientation() {
  if (process.client) return;
  const headers = useRequestHeaders();
  const userAgent = headers["user-agent"] || "";
  const isMobile =
    /Mobile|Android|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent,
    );
  isPortrait.value = isMobile ? true : false;
}

// set referer cookie
if (process.server) {
  checkServerOrientation();
  const referer = headers.referer || "";
  const prevReferer = useCookie("visitor_referer");
  if (
    referer &&
    (!prevReferer.value || prevReferer.value.includes("travvir.com"))
  ) {
    const refererCookie = useCookie("visitor_referer", {
      maxAge: 15 * 60,
      path: "/",
    });
    refererCookie.value = referer;
  }
}

if (process.client) {
  updateOrientation();
}

onMounted(() => {
  window.addEventListener("resize", updateOrientation);
  window.addEventListener("orientationchange", updateOrientation);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateOrientation);
  window.removeEventListener("orientationchange", updateOrientation);
});
</script>
